/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CreateWebhook200} from './schemas/create-webhook200';

import type {CrupdateWebhookBody} from './schemas/crupdate-webhook-body';

import type {ListWebhookAttemptsParams} from './schemas/list-webhook-attempts-params';

import type {ListWebhookAttempts200} from './schemas/list-webhook-attempts200';

import type {ListWebhooks200} from './schemas/list-webhooks200';

import type {RetrieveWebhookAttempt200} from './schemas/retrieve-webhook-attempt200';

import type {RetrieveWebhook200} from './schemas/retrieve-webhook200';

import type {SendTestWebhookEventBody} from './schemas/send-test-webhook-event-body';

import type {UpdateWebhook200} from './schemas/update-webhook200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all webhooks
 */
export const listWebhooks = (
  options?: SecondParameter<typeof orvalApiFetch<ListWebhooks200>>,
) => {
  return orvalApiFetch<ListWebhooks200>(
    {url: `/webhooks`, method: 'GET'},
    options,
  );
};
/**
 * @summary Create a webhook
 */
export const createWebhook = (
  crupdateWebhookBody?: CrupdateWebhookBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateWebhook200>>,
) => {
  return orvalApiFetch<CreateWebhook200>(
    {
      url: `/webhooks`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateWebhookBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a webhook
 */
export const retrieveWebhook = (
  id: string,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveWebhook200>>,
) => {
  return orvalApiFetch<RetrieveWebhook200>(
    {url: `/webhooks/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a webhook
 */
export const updateWebhook = (
  id: string,
  crupdateWebhookBody?: CrupdateWebhookBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateWebhook200>>,
) => {
  return orvalApiFetch<UpdateWebhook200>(
    {
      url: `/webhooks/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateWebhookBody,
    },
    options,
  );
};
/**
 * @summary Delete a webhook
 */
export const deleteWebhook = (
  id: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/webhooks/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary List webhook delivery attempts
 */
export const listWebhookAttempts = (
  id: string,
  params?: ListWebhookAttemptsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListWebhookAttempts200>>,
) => {
  return orvalApiFetch<ListWebhookAttempts200>(
    {url: `/webhooks/${id}/attempts`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Retrieve a webhook delivery attempt
 */
export const retrieveWebhookAttempt = (
  webhookId: string,
  attemptId: string,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveWebhookAttempt200>>,
) => {
  return orvalApiFetch<RetrieveWebhookAttempt200>(
    {url: `/webhooks/${webhookId}/attempts/${attemptId}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Send a test webhook event
 */
export const sendTestWebhookEvent = (
  id: string,
  sendTestWebhookEventBody: SendTestWebhookEventBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/webhooks/${id}/send-test-event`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: sendTestWebhookEventBody,
    },
    options,
  );
};
/**
 * @summary Enable a disabled webhook
 */
export const enableWebhook = (
  id: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/webhooks/${id}/enable`, method: 'POST'},
    options,
  );
};
/**
 * @summary Disable a webhook
 */
export const disableWebhook = (
  id: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/webhooks/${id}/disable`, method: 'POST'},
    options,
  );
};
export type ListWebhooksResult = NonNullable<
  Awaited<ReturnType<typeof listWebhooks>>
>;
export type CreateWebhookResult = NonNullable<
  Awaited<ReturnType<typeof createWebhook>>
>;
export type RetrieveWebhookResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWebhook>>
>;
export type UpdateWebhookResult = NonNullable<
  Awaited<ReturnType<typeof updateWebhook>>
>;
export type DeleteWebhookResult = NonNullable<
  Awaited<ReturnType<typeof deleteWebhook>>
>;
export type ListWebhookAttemptsResult = NonNullable<
  Awaited<ReturnType<typeof listWebhookAttempts>>
>;
export type RetrieveWebhookAttemptResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWebhookAttempt>>
>;
export type SendTestWebhookEventResult = NonNullable<
  Awaited<ReturnType<typeof sendTestWebhookEvent>>
>;
export type EnableWebhookResult = NonNullable<
  Awaited<ReturnType<typeof enableWebhook>>
>;
export type DisableWebhookResult = NonNullable<
  Awaited<ReturnType<typeof disableWebhook>>
>;
